export const SOCIAL_PAGES = {
  facebook: 'https://www.facebook.com/stayforlong/',
  instagram: 'https://www.instagram.com/stayforlong/',
  linkedin: 'https://www.linkedin.com/company/stayforlong/',
  tiktok: 'https://www.tiktok.com/@stayforlong',
}

export const EXTERNAL_LINKS = {
  reviews: 'https://www.trustpilot.com/review/stayforlong.com',
}
